import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Logo from '../assets/img/dr-mario-arcila-logo.webp'
import Rejuvenece from '../components/Hardcoded/Rejuvenece'
    

function RejuvenecePage() {
  return (
    <div>
        <Header logoSrc={Logo}/>
        <Rejuvenece />
        <Footer logoSrc={Logo}/>
    </div>
  );
}

export default RejuvenecePage;
